import React from 'react'
import { DataTable } from './NoNotes/DataTable'

const NoNotes = () => {
  return (
    <div className="space-y-4">
      <DataTable />
    </div>
  )
}
export default NoNotes
